import { Skeleton } from '@/shared/components/ui/skeleton';
import {
  EngagementsBannerSkeleton,
  KPICardsSkeleton,
  ChartSkeleton,
  MapSkeleton,
  BreakdownsSkeleton,
} from '../shared/AnalyticsSkeletons';

type OverviewSectionSkeletonProps = {
  title: string;
  variant?: 'engagements' | 'logins' | 'search' | 'coverage' | 'default';
};

export const OverviewSectionSkeleton = ({
  title,
  variant = 'default',
}: OverviewSectionSkeletonProps) => (
  <section>
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
    </div>
    <SectionSkeletonContent variant={variant} />
  </section>
);

const SectionSkeletonContent = ({
  variant,
}: {
  variant: OverviewSectionSkeletonProps['variant'];
}) => {
  switch (variant) {
    case 'engagements':
      return (
        <div className="space-y-6">
          <EngagementsBannerSkeleton />
          <ChartSkeleton height="h-[300px]" />
          <BreakdownsSkeleton />
        </div>
      );
    case 'logins':
      return (
        <div className="space-y-6">
          <KPICardsSkeleton count={4} />
          <ChartSkeleton height="h-[320px]" />
          <ChartSkeleton height="h-[320px]" />
        </div>
      );
    case 'search':
      return (
        <div className="space-y-4">
          <Skeleton className="h-9 w-80" />
          <MapSkeleton />
        </div>
      );
    case 'coverage':
      return (
        <div className="space-y-4">
          <Skeleton className="h-10 w-full max-w-md" />
          <MapSkeleton />
        </div>
      );
    default:
      return (
        <div className="space-y-4">
          <Skeleton className="h-28 w-full rounded-lg" />
          <Skeleton className="h-72 w-full rounded-lg" />
        </div>
      );
  }
};
